import Vue from "vue";
import Vuex from "vuex";
import { lowerCase, uniq } from "lodash";

Vue.use(Vuex);

// data
import data from "./data.json";

export default new Vuex.Store({
  state: { data, favList: [] },
  mutations: {
    fillFavList(state, payload) {
      state.favList = payload;
    },
    emptyFav(state) {
      state.favList = [];
    },
  },
  actions: {
    findOneById({ getters }, id) {
      return getters.getAll.find((el) => el.ID === parseInt(id));
    },
    findOneBySlug({ getters }, slug) {
      return getters.getAll.find((el) => el.TITLE === slug);
    },
    toggleFav({ commit, getters }, slug) {
      slug = lowerCase(slug);
      let list = getters.getFavListFromLocalStorage;
      if (!list.includes(slug)) {
        list.push(slug);
      } else {
        list.splice(list.indexOf(slug), 1);
      }
      list = uniq(list);

      window.localStorage.setItem("favlist", JSON.stringify(list));
      commit("fillFavList", list);
      return list.includes(slug);
    },
  },
  getters: {
    getFavListFromLocalStorage() {
      return JSON.parse(window.localStorage.getItem("favlist")) || [];
    },
    inFavList: ({ favList }) => (payload) => {
      return favList.includes(lowerCase(payload));
    },
    getAll({ data }) {
      return data;
    },
    getFavList({ data, favList }) {
      if (favList.length > 0) {
        const adkarList = [];
        favList.forEach((element) => {
          data.forEach((dikr) => {
            if (lowerCase(dikr.TITLE) === lowerCase(element)) {
              adkarList.push(dikr);
            }
          });
        });
        return adkarList;
      }
    },
  },
});
